<template>
  <div class="wrapper">
    <div>
    <CRow class="mt-3">
      <div>  
      </div>
      <CCol sm="12">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :checked="checked"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @assign_user="handleAssign_User"
                            @assign_permission="handleAssign_Permission"
                            @edit="handleEdit"
                            @destroy="handleDestroy"

                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
      
      <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script>
import Datatable from '@/components/datatables_role_user.vue'
import axios from 'axios'

import keperluan from '@/services/keperluan'
import roles from '@/services/roles'

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

const token = localStorage.getItem('token');

export default {
  name: 'KeperluanTables',
  components: { alertmodal, Datatable },
  data(){
    return{
      form:{
        users:[]
      },
      updateSubmit: false,
      largeModal:false,
      datas:[], 

      fields: [
          {key: 'check', sortable: false},
          {key: 'full_name', sortable: false, },
          {key: 'email', sortable: false, },
      ],
      items: [],
      meta: [],
      checked: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'id',
      sortByDesc: false,
      //is_active: 1,
    }
  },

  created() {
      //this.loadData()
      //this.loadChecked()
  },
  mounted (){
     this.loadData()
     

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

   },
   
  methods: {
    openModal: function () {
      var params = {title: 'Add New Necessary', mode:'create'}
      EventBus.$emit('OPEN_MODAL_KEPERLUAN', params)
    },
    

    assignuser(id,data){
      this.form.users = data
      console.log(id + this.form)

      // roles.assignUserToRole(id,this.form)
      // .then(res => {
      //   //EventBus.$emit('TABLE_UPDATE', true)
      //   var params = {title: 'Success', mode:'success', data:res.message}
      //   EventBus.$emit('OPEN_MODAL_ALERT', params)
      // }).catch ((err) => {
      //   var params = {title: 'Error', mode:'danger', data:err.response.data.message}
      //   EventBus.$emit('OPEN_MODAL_ALERT', params)
      // })

    },

    openModalEdit(id){
        var params = {title: 'Edit Necessary', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_KEPERLUAN', params)
    },

    deactivate(id){
      if(confirm("Do you really want to deactivate?")){
        keperluan.deactivateKeperluan(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },

    reactivate(id){
      if(confirm("Do you really want to reactivate?")){
        keperluan.reactivateKeperluan(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      roles.getAvailableUserDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.checked = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
          //this.checked = ['5','6']
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    loadChecked() {
      roles.getViewUser('13')
      .then(res => {
          let getData = res.members
          //this.checked = ['5','6']
          //this.checked = getData
          for (var i = 0; i < getData.length; i++) {
            console.log(getData[i].id);
            this.checked.push(getData[i].id);
          }

      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleAssign_User(val1,val2) {
        this.assignuser(val1,val2) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleAssign_Permission(val) {
        this.deactivate(val)       
    },
    handleDestroy(val) {
        this.deactivate(val)       
    },

  }
}
</script>